import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const geotabConfig: TSPConfig = {
  key: 'geotab',
  name: 'Geotab',
  category: TSPCategory.CUSTOM,
  helpText:
    'Input the credentials and database you use to log into the Geotab Web App.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Username', name: 'username', type: 'text', required: true },
        {
          label: 'Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        { label: 'Database', name: 'database', type: 'text', required: true },
      ]}
    />
  ),
};

export default geotabConfig;
